export default function Gallery() {
    if (document.readyState === 'loading') {
        // Add event listener if the document is still loading
        document.addEventListener('DOMContentLoaded', initProductGallery);
    } else {
        // Run the function immediately if the DOM is already loaded
        initProductGallery();
    }
    function initProductGallery() {
        if (!document.querySelector('.product-gallery__large')) {
            return;
        }
        const selectors = {
            largeImageContainer: '.product-gallery__large',
            largeImage: '.product-gallery__large img',
            thumbImages: '.product-gallery__thumbs img',
        };

        const state = {
            currentIndex: 0,
        };

        const { largeImageContainer, largeImage, thumbImages } = cacheDOMElements(selectors);
        setInitialImage();
        preloadImages(thumbImages);
        bindEvents();

        function cacheDOMElements(selectors) {
            return {
                largeImageContainer: document.querySelector(selectors.largeImageContainer),
                largeImage: document.querySelector(selectors.largeImage),
                thumbImages: document.querySelectorAll(selectors.thumbImages),
            };
        }

        function setInitialImage() {
            thumbImages[0].parentNode.classList.add('product-gallery__thumb--selected');
        }

        function preloadImages(thumbImages) {
            thumbImages.forEach(thumb => {
                if (thumb.getAttribute('data-full-res').startsWith("video:")) {
                    return; // Skip video thumbnails
                }
                const img = new Image();
                img.src = thumb.getAttribute('data-full-res');
            });
        }

        function updateImage(index) {
            const adjustedIndex = adjustIndex(index, thumbImages.length);
            const selectedSource = thumbImages[adjustedIndex].getAttribute('data-full-res');

            if (selectedSource.startsWith("video:")) {
                const videoSrc = selectedSource.substring(6); // Remove "video:" marker
                const videoPoster = thumbImages[adjustedIndex].src;
                const videoElement = document.createElement('video');
                videoElement.controls = true;
                videoElement.preload = 'auto';
                videoElement.poster = videoPoster;
                const sourceElement = document.createElement('source');
                sourceElement.src = videoSrc;
                sourceElement.type = 'video/mp4';
                videoElement.appendChild(sourceElement);

                if (largeImageContainer.firstChild.tagName === 'VIDEO') {
                    const existingVideoSrc = largeImageContainer.firstChild.querySelector('source').src;
                    if (existingVideoSrc !== videoSrc) {
                        largeImageContainer.innerHTML = '';
                        largeImageContainer.appendChild(videoElement);
                    }
                } else {
                    largeImageContainer.innerHTML = '';
                    largeImageContainer.appendChild(videoElement);
                }
            } else {
                if (largeImage.src !== selectedSource) {
                    largeImage.src = selectedSource;
                    largeImageContainer.innerHTML = ''; // Clear any existing video
                    largeImageContainer.appendChild(largeImage); // Add the image back if it was removed
                }
            }
            highlightThumbnail(adjustedIndex);
            state.currentIndex = adjustedIndex;
        }

        function adjustIndex(index, length) {
            if (index < 0) return length - 1;
            if (index >= length) return 0;
            return index;
        }

        function highlightThumbnail(index) {
            thumbImages.forEach(thumb => thumb.parentNode.classList.remove('product-gallery__thumb--selected'));
            thumbImages[index].parentNode.classList.add('product-gallery__thumb--selected');
        }

        function bindEvents() {
            thumbImages.forEach((thumb, index) => {
                thumb.addEventListener('click', () => updateImage(index));
                thumb.addEventListener('mouseenter', () => previewImage(index));
                thumb.addEventListener('mouseleave', () => updateImage(state.currentIndex));
            });


            largeImageContainer.addEventListener('mousemove', zoomImage);
            largeImageContainer.addEventListener('mouseleave', resetZoom);
        }

        function previewImage(index) {
            const largeContent = document.querySelector('.product-gallery__large').firstChild;
            if (largeContent.tagName === 'VIDEO') return;
            let src = thumbImages[index].getAttribute('data-full-res');
            if (src.startsWith("video:")) {
                src = thumbImages[index].src + '?video=1';
            }
            largeImage.src = src;
        }

        function zoomImage(event) {
            const largeContent = document.querySelector('.product-gallery__large').firstChild;
            if (largeContent.tagName === 'VIDEO' || window.innerWidth <= 768) return; // Disable zoom for video

            const { offsetX, offsetY } = getMousePositionInElement(event, largeImageContainer);
            toggleZoom(true, offsetX, offsetY);
        }

        function resetZoom() {
            const largeContent = document.querySelector('.product-gallery__large').firstChild;
            if (largeContent.tagName === 'VIDEO') return; // Disable reset zoom for video

            toggleZoom(false);
        }

        function toggleZoom(enabled, x = 50, y = 50) {
            largeImageContainer.classList.toggle('zoomed', enabled);
            largeImage.style.transformOrigin = `${x}% ${y}%`;
        }

        function getMousePositionInElement(event, element) {
            const bounds = element.getBoundingClientRect();
            const x = ((event.clientX - bounds.left) / bounds.width) * 100;
            const y = ((event.clientY - bounds.top) / bounds.height) * 100;
            return { offsetX: x, offsetY: y };
        }
    }
}